<div class="fx-affiliate-create">
  <div class="row">
    <div class="col">
      <fx-page-header title="{{'Create Link'}}"></fx-page-header>
    </div>
  </div>
  <div class="card bg-dark-lighter text-white mb-3">
    <div class="card-body">
      <div class="row fs-16">
        <div class="col">
          <span class="text-red">{{'User - '}}</span>
          <span>{{ 'Affiliate Link Creation' }}</span>
        </div>
      </div>
      <form class="form" #formMam="ngForm" autocomplete="off"
            (ngSubmit)="onCreateUser()">
        <div class="row mt-4">
          <div class="col-md-6 col-xs-12">
            <mat-form-field appearance="fill" floatLabel="auto">
              <mat-label>{{'Affiliate links Name'}}</mat-label>
              <input
                matInput
                type="text"
                placeholder=""
                name="linkname"
                [(ngModel)]="user.linkname"
                #linkname="ngModel"
                required
                disabled="{{!permission.allowCreating}}"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-6 col-xs-12">
            <mat-form-field appearance="fill" floatLabel="auto">
              <mat-label>MT5 Group</mat-label>
              <mat-select name="group" [(ngModel)]="user.group" multiple
                          (selectionChange)="onChangeConfigTrade()"
                          required
                          disabled="{{!permission.allowCreating}}">
                <mat-option *ngFor="let item of listConfigTrader" [value]="item.id">
                  <span labelGroup="{{item.name}}"></span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row" *ngIf="permission.allowCreating">
          <div class="col-md-6 col-xs-12">
            <button class="btn btn-main w-100 fs-16" type="submit">Create</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="card bg-dark-lighter text-white mb-3">
    <div class="card-body">
      <div class="row fs-16">
        <div class="col">
          <span class="text-green">{{'IB - '}}</span>
          <span>{{ 'Affiliate Link Creation' }}</span>
        </div>
      </div>
      <form class="form" #formIB="ngForm" autocomplete="off"
            (ngSubmit)="onCreateIB()">
        <div class="row mt-4">
          <div class="col-md-6 col-xs-12">
            <mat-form-field appearance="fill" floatLabel="auto">
              <mat-label>{{'Affiliate links Name'}}</mat-label>
              <input matInput type="text" name="link" [(ngModel)]="ib.link" #link="ngModel" required [maxlength]="128" (input)="trimStart($event)" [trimValidator]="true"
                disabled="{{!permission.allowCreating}}" />
              <mat-error *ngIf="link.errors">
                <span class="errors-group error-message"
                  *ngIf="link.errors?.required && (link?.dirty || link?.touched || formIB?.submitted)">
                  Affiliate link is required
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-xs-12 check-box">
            <input
              type="checkbox"
              name="type"
              [(ngModel)]="ib.type"
              (ngModelChange)="selectedAllGroup($event)"
            />
            <span class="text-white">Set as Organic IB registration link</span>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-6 col-xs-12">
            <mat-form-field appearance="fill" floatLabel="auto">
              <mat-label>MT5 Group</mat-label>
              <mat-select name="ibgroup" [(ngModel)]="ib.ibgroup" multiple  #ibgroup="ngModel"
                          required
                          disabled="{{!permission.allowCreating}}">
                <mat-option *ngFor="let item of listConfig" [value]="item.id">
                  <span labelGroup="{{item.name}}"></span>
                </mat-option>
              </mat-select>
              <mat-error *ngIf="ibgroup.errors">
                <span class="errors-group error-message"
                  *ngIf="ibgroup.errors?.required && (ibgroup?.dirty || ibgroup?.touched || formIB?.submitted)">
                  MT5 group is required
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        
        <!-- <div class="row mt-2">
          <div class="col-md-6 col-xs-12">
            <div class="row">
              <div class="col">
                <mat-form-field appearance="fill" floatLabel="auto">
                  <mat-label>{{'Pip'}}</mat-label>
                  <input
                    matInput
                    type="number"
                    placeholder=""
                    name="pip"
                    [(ngModel)]="ib.pip"
                    #pip="ngModel"
                    required
                    disabled="{{!permission.allowCreating}}"
                  />
                  <span matSuffix>pip</span>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field appearance="fill" floatLabel="auto">
                  <mat-label>{{'Commission'}}</mat-label>
                  <input
                    matInput
                    type="number"
                    placeholder=""
                    name="commission"
                    [(ngModel)]="ib.commission"
                    #commission="ngModel"
                    required
                    disabled="{{!permission.allowCreating}}"
                  />
                  <span matSuffix>%</span>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-6 col-xs-12">
            <mat-form-field appearance="fill" floatLabel="auto">
              <mat-label>{{'Percentage'}}</mat-label>
              <input
                matInput
                type="number"
                placeholder=""
                name="rate"
                [(ngModel)]="ib.rate"
                #rate="ngModel"
                required
                disabled="{{!permission.allowCreating}}"
              />
              <span matSuffix>%</span>
            </mat-form-field>
          </div>
        </div> -->
        <div class="row mt-2" *ngIf="permission.allowCreating">
          <div class="col-md-6 col-xs-12">
            <button class="btn btn-main w-100 fs-16" type="submit">Create</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
